import { render, staticRenderFns } from "./alert-box.vue?vue&type=template&id=6bdcdda4&scoped=true&"
import script from "./alert-box.vue?vue&type=script&lang=js&"
export * from "./alert-box.vue?vue&type=script&lang=js&"
import style0 from "./alert-box.vue?vue&type=style&index=0&id=6bdcdda4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdcdda4",
  null
  
)

export default component.exports